var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _vm._v(" " + _vm._s(_vm.$t("learner.get-started")) + " "),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue" },
                  on: { click: _vm.showShortcodeGenerator }
                },
                [_vm._v(" " + _vm._s(_vm.$t("welcome.get-access-code")) + " ")]
              )
            ],
            1
          ),
          _c("v-card-text", [
            _c("h3", [
              _vm._v(
                _vm._s(_vm.$t("learner.welcome-title", [_vm.userFirstName]))
              )
            ]),
            _c("br"),
            _c("div", { staticClass: "twocolumns" }, [
              _c("p", [_vm._v(_vm._s(_vm.$t("welcome.accces-instructions")))]),
              _vm.isStreamingEnabled
                ? _c("p", [
                    _vm._v(
                      " " + _vm._s(_vm.$t("welcome.stream-instructions")) + " "
                    )
                  ])
                : _vm._e(),
              _c("p", [_vm._v(_vm._s(_vm.$t("welcome.play-links")))]),
              _c("p", [_vm._v(_vm._s(_vm.$t("welcome.access-code")))])
            ])
          ])
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500px" },
              model: {
                value: _vm.showGenerator,
                callback: function($$v) {
                  _vm.showGenerator = $$v
                },
                expression: "showGenerator"
              }
            },
            [
              _c(
                "shortcode-generator",
                {
                  ref: "generator",
                  attrs: {
                    action: "userLogin",
                    title: _vm.$t("welcome.generate-access-code"),
                    "no-button": ""
                  }
                },
                [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("welcome.generator-instructions1")))
                  ]),
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("welcome.generator.instructions2")) + " "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            return _vm.refreshCode()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("launch.step3.here")))]
                    )
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }